"use client";

import { useGSAP } from "@/lib/motion/gsap";
import { useMotionBag } from "@/components/site/motion/MotionContext";
import type { SiteMotion } from "@/lib/motion/site-runtime";

/** Run a spine slice after page boot / resize (epoch). */
export function useSpineSlice(build: (motion: SiteMotion) => void) {
  const { motion, epoch } = useMotionBag();
  useGSAP(
    () => {
      if (!epoch || !motion.spine) return;
      build(motion);
    },
    { dependencies: [epoch], revertOnUpdate: true },
  );
}
